import { Api } from "../api/Api";
import {useErrorWebhook} from "./useErrorWebhook";

export const useFollowupUserSignature = () => {

  const { ErrorWebhookTrigger } = useErrorWebhook();
  const saveFollowupUserSignature = async (
    signature_data,
    followup_data,
    message_type,
    pdf_generation
  ) => {
    const signatureSubmit = await Api.post("/api/v1/data-ingestion-pipeline", {
      signature_data,
      followup_data,
      message_type,
      pdf_generation
    }).catch(function (error) {
      const erroMessage = {
        serviceName : 'Data Ingestion : '+message_type,
        errorReason:error.message,
        errorCode:error.code,
      }
      ErrorWebhookTrigger(erroMessage);
    });
    return signatureSubmit;
  };
  const saveFollowupUserSignatureDSAR = async (
    signature_data,
    followup_data,
    message_type,
    dsar
  ) => {
    const signatureSubmit = await Api.post("/api/v1/data-ingestion-pipeline", {
      signature_data,
      followup_data,
      message_type,
      dsar
    }).catch(function (error) {
      const erroMessage = {
        serviceName : 'Data Ingestion : '+message_type,
        errorReason:error.message,
        errorCode:error.code,
      }
      ErrorWebhookTrigger(erroMessage);
    });
    return signatureSubmit;
  };
  return {
    saveFollowupUserSignature,
    saveFollowupUserSignatureDSAR 
  };
};
